module.exports = __webpack_public_path__ + "img/bell_3.45f14a0a.jpg";